import { render, staticRenderFns } from "./TabBatchDetail.vue?vue&type=template&id=7fbc70a1&"
import script from "./TabBatchDetail.vue?vue&type=script&lang=js&"
export * from "./TabBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./TabBatchDetail.vue?vue&type=style&index=0&id=7fbc70a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports